import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0e7dbac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = {
  key: 0,
  class: "title-wrapper"
}
const _hoisted_3 = {
  class: "title",
  id: 'time-slider-title'
}
const _hoisted_4 = {
  class: "time-range",
  "aria-live": "polite"
}
const _hoisted_5 = { class: "range-slider" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-selected" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "range-unit" }
const _hoisted_8 = {
  class: "range-input",
  ref: "rangeInputRef"
}
const _hoisted_9 = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-valuetext"]
const _hoisted_10 = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-valuetext"]
const _hoisted_11 = {
  key: 1,
  class: "range-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "time-slider-container",
    role: "group",
    "aria-labelledby": $props.title ? 'time-slider-title' : undefined
  }, [
    ($props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString($props.title), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_4, _toDisplayString(`${$setup.useConvertNumberToTimeText($setup.fromHour)}~${$setup.useConvertNumberToTimeText(
            $setup.toHour
          )}`), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($props.maxHourRange - $props.minHourRange) / $props.step + 1, (hour) => {
          return (_openBlock(), _createElementBlock("div", {
            key: hour,
            class: "unit-point"
          }))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "thumb min",
        style: _normalizeStyle({ left: $setup.thumbMinLeft }),
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => ($setup.startDrag('min', $event))),
        onTouchstart: _cache[1] || (_cache[1] = ($event: any) => ($setup.startDrag('min', $event))),
        role: "slider",
        "aria-label": `${$props.title ?? '시간'} 시작값 조절`,
        "aria-valuenow": $setup.fromHour,
        "aria-valuemin": $props.minHourRange,
        "aria-valuemax": $props.maxHourRange,
        "aria-valuetext": $setup.useConvertNumberToTimeText($setup.fromHour),
        tabindex: "0",
        onKeydown: _cache[2] || (_cache[2] = ($event: any) => ($setup.onKeyDown('min', $event)))
      }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_9),
      _createElementVNode("div", {
        class: "thumb max",
        style: _normalizeStyle({ left: $setup.thumbMaxLeft }),
        onMousedown: _cache[3] || (_cache[3] = ($event: any) => ($setup.startDrag('max', $event))),
        onTouchstart: _cache[4] || (_cache[4] = ($event: any) => ($setup.startDrag('max', $event))),
        role: "slider",
        "aria-label": `${$props.title ?? '시간'} 종료값 조절`,
        "aria-valuenow": $setup.toHour,
        "aria-valuemin": $props.minHourRange,
        "aria-valuemax": $props.maxHourRange,
        "aria-valuetext": $setup.useConvertNumberToTimeText($setup.toHour),
        tabindex: "0",
        onKeydown: _cache[5] || (_cache[5] = ($event: any) => ($setup.onKeyDown('max', $event)))
      }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_10)
    ], 512 /* NEED_PATCH */),
    ($props.labelStep)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getRangeLabel, (label) => {
            return (_openBlock(), _createElementBlock("span", { key: label }, _toDisplayString(label), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}